import { FieldValidatorType } from '@progress/kendo-react-form';
import { useIntl } from 'hooks/intl';

/**
 * バリデーション.
 * @see https://pjsite.sharepoint.com/:x:/r/sites/--8249/Shared%20Documents/General/%E8%A9%B3%E7%B4%B0%E8%A8%AD%E8%A8%88%E6%9B%B8/10_%E5%80%8B%E5%88%A5%E3%82%B5%E3%83%BC%E3%83%93%E3%82%B9/%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB%E7%AE%A1%E7%90%86%E3%83%9D%E3%83%BC%E3%82%BF%E3%83%AB/%E7%94%BB%E9%9D%A2%E8%A8%AD%E8%A8%88%E6%9B%B8/DAT740_%E3%83%A1%E3%83%83%E3%82%BB%E3%83%BC%E3%82%B8%E4%B8%80%E8%A6%A7_%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB%E7%AE%A1%E7%90%86%E3%83%9D%E3%83%BC%E3%82%BF%E3%83%AB.xlsx?d=w1bfac3a0ee9643db9307b3f23ba38dbc&csf=1&web=1&e=qenlWq
 */
export const useValidations = () => {
  const intl = useIntl();

  /**
   * 必須入力.
   * @return 値がtruthyでない場合: バリデーションエラー
   */
  const required = (): FieldValidatorType => (value: string) => (!value
    ? intl.formatMessage('validation.required.message')
    : '');

  /**
   * 最大.
   * @param max 最大値
   * @return 値の文字数がmax以上の場合: バリデーションエラー
   */
  const maxLength = (max: number): FieldValidatorType => (value: string) => {
    if (!value) { return undefined; }
    return value.length > max
      ? intl.formatMessage('validation.max.message', [`${max}`])
      : '';
  };

  /**
   * 最小.
   * @param min 最大値
   * @return 値の文字数がmin以下の場合: バリデーションエラー
   */
  const minLength = (min: number): FieldValidatorType => (value: string) => {
    if (!value) { return undefined; }
    return value.length < min
      ? intl.formatMessage('validation.min.message', [`${min}`])
      : '';
  };

  /**
   * 範囲.
   * @param min 最小値
   * @param max 最大値
   * @return 値がmin~maxの間にない場合: バリデーションエラー
   */
  const range = (min: number, max: number): FieldValidatorType => (value: number | null | undefined) => {
    if (value === null || value === undefined) { return undefined; }
    const invalid = min > value || max < value;
    return invalid
      ? intl.formatMessage('validation.range.message', [`${min}`, `${max}`])
      : '';
  };

  /**
   * フォーマット.
   * @param regex 正規表現
   * @return 正規表現に一致しない場合: バリデーションエラー
   */
  const formatRegExp = (regex: RegExp): FieldValidatorType => (value: string) => {
    if (!value) { return undefined; }
    return !regex.test(value)
      ? intl.formatMessage('validation.formatRegExp.message', [`${regex}`])
      : '';
  };

  /**
   * URI
   * @param field フィールド
   * @return 先頭がURL形式でない場合: バリデーションエラー
   */
  const uri = (): FieldValidatorType => (value: string) => {
    if (!value) { return undefined; }
    const startWidth = /(^http:.*$|^https:.*$|^ftpURL:.*$)/;
    return !startWidth.test(value)
      ? intl.formatMessage('validation.uri.message')
      : '';
  };

  /**
   * 整数.
   * @return 整数ではない場合: バリデーションエラー
   */
  const integer = (): FieldValidatorType => (value: string) => {
    if (!value) { return undefined; }
    return !/^[+-]?[0-9]+$/.test(value)
      ? intl.formatMessage('validation.integer.message')
      : '';
  };

  /** TODO 日付 */
  /** TODO 日時 */
  /** TODO 数値 */
  /** TODO 不正 */

  return {
    required,
    maxLength,
    minLength,
    range,
    formatRegExp,
    uri,
    integer,
  };
};
